import React from "react";
import styled, { keyframes } from "styled-components";

// The machine turning on: a beat of BIOS-ish self-test text on black,
// then straight to the logon dialog. All original — no Microsoft art
// or text.

const POST_LINES = [
  "eieio systems self-test",
  "",
  "Memory Test :  65536K OK",
  "Video       :  VGA 640x480, 256 colors",
  "Pointer     :  found",
  "Sound       :  found (quiet)",
  "",
  "Booting from C: ...",
];

// `waiting`: still finding a seat — appends a live BIOS-ish status
// line (the POST doubles as the loading screen). `instant`: no
// type-in (used when the text already typed during the connect wait).
function BootScreen({ waiting = false, instant = false }) {
  const lines = waiting
    ? [...POST_LINES, "Finding you a game ..."]
    : POST_LINES;
  return (
    <Screen>
      <PostText>
        {lines.map((line, i) => (
          <PostLine
            key={i}
            style={{ "--delay": (instant ? 0 : i * 90) + "ms" }}
          >
            {line === "" ? " " : line}
          </PostLine>
        ))}
      </PostText>
    </Screen>
  );
}

const Screen = styled.div`
  position: fixed;
  inset: 0;
  z-index: 6000;
  background: #000;
  color: #b8b8b8;
  cursor: none;
`;

const PostText = styled.div`
  padding: 28px 34px;
  font-family: "Courier New", monospace;
  font-size: 15px;
  line-height: 1.45;
  white-space: pre;
`;

const lineIn = keyframes`
  from { visibility: hidden; }
  to   { visibility: visible; }
`;

const PostLine = styled.p`
  animation: ${lineIn} 0ms steps(1, end) var(--delay) both;
`;

export default BootScreen;
